import React, { FC, ReactElement } from "react";
import { Box, Container, Divider, Grid, IconButton, List, ListItemButton, Typography } from "@mui/material";
import { Facebook, Instagram, MenuBook } from "@mui/icons-material";
import { Link } from 'react-router-dom';

export const Footer = () => {

   const itemList = [
      {
      text: "Contact",
      to: "/contact"
      },
      {
      text: "Termes et conditions",
      to: "/terms"
      },
   ];

  return (
    <Box
      sx={{
            backgroundColor: "#FBFCFA",
            width: "100%",
         }}
    >
   <Box
      sx={{
         width: "100%",
         display: "flex",
         textAlign: "center",
         alignItems: "center",
         justifyContent: "center",
         paddingY: 1,
         flexDirection: { xs: "column", md: "row" },
      }}
   >
      <Box
         sx={{
            textAlign: "start",
            width: "100%",
         }}
      >
         <Typography
            color="#16191e"
            variant="h5"
            sx={{
               ml: { md: 0, xs: 'auto' }, // Ajoute un margin à gauche uniquement sur les grands écrans
               textDecoration: { xs: "underline", md: "none" },
               textAlign: "center",
            }}
         >
            Le Chai
         </Typography>
      </Box>
      <Box
         sx={{
            textAlign: "center",
            width: "100%",
         }}
      >
         <List
            sx={{
               display: "flex",
               flexDirection: {xs: "column", md: "row"},
               alignItems: "center",
               justifyContent: "center",
               gap: {xs: 0, md: 1},
            }}
         >
            {itemList.map((item, index) => (
               <ListItemButton
                  key={index}
                  component={Link}
                  to={item.to}
                  sx={{
                     textAlign: "center",
                     justifyContent: "center",
                     color: "#16191e",
                     width: "fit-content", // Permet au bouton de s'adapter au contenu
                  }}
                  >
                  {item.text}
               </ListItemButton>
            ))}
         </List>
      </Box>
      <Box
         sx={{
            alignContent: "end",
            width: "100%",
         }}
      >
         <List
            sx={{
               display: "flex",
               flexDirection: "row",
               justifyContent: "center",
               alignItems: "center",
               textAlign: "center",
               width: '100%',
               gap: 1,
            }}
         >
            <IconButton
               href="https://www.instagram.com/lechai_metz_officiel/"
               target="_blank" // Ouvre le lien dans un nouvel onglet
               rel="noopener noreferrer" // Améliore la sécurité lors de l'ouverture dans un nouvel onglet
               sx={{
                  color: '#16191e', // Définit la couleur de l'icône en blanc
               }}
               >
               <Instagram />
            </IconButton>
            <IconButton
               href="https://www.facebook.com/LeChaiMetz/"
               target="_blank" // Ouvre le lien dans un nouvel onglet
               rel="noopener noreferrer" // Améliore la sécurité lors de l'ouverture dans un nouvel onglet 
               sx={{
                  color: '#16191e', // Définit la couleur de l'icône en blanc
               }}
            >
               <Facebook/>
            </IconButton>
            <IconButton
               href="https://www.petitfute.com/v21702-augny-57685/c650-produits-gourmands-vins/c1117-vins-alcools-boissons-sans-alcool/2183743-le-chai.html"
               target="_blank" // Ouvre le lien dans un nouvel onglet
               rel="noopener noreferrer" // Améliore la sécurité lors de l'ouverture dans un nouvel onglet 
               sx={{
                  color: '#16191e', // Définit la couleur de l'icône en blanc
               }}
            >
               <MenuBook/>
            </IconButton>
         </List>
         </Box>
   </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Divider
          orientation="horizontal"
          sx={{
            backgroundColor: "#16191e",
            width: '90%', // Ajustez la largeur du Divider comme nécessaire
          }}
        />
      </Box>
   <Box
      sx={{
         width: "100%",
         display: "flex",
         textAlign: "center", // Centrer le texte
         alignItems: "center", // Centrer verticalement
         justifyContent: "space-between", // Centrer horizontalement
         flexDirection: {xs: "column", md: "row"},
         paddingTop: 1,
         paddingBottom: 3
      }}
   >
      <Box>
         <Typography
            variant="subtitle"
            sx={{
               color: "#16191e",
               fontSize: 12,
               paddingLeft: {xs: 0, md:5},
            }} 
         >
            {`${new Date().getFullYear()} © SAS SOVIME | Tous droits réservés`}   
         </Typography>
      </Box>
      <Box>
         <Typography
            variant="subtitle"
            sx={{
               color: "#16191e",
               fontSize: 12,
               paddingRight: {xs: 0, md:5},
            }} 
         >
            {`L'abus d'alcool est dangereux pour la santé.`}
         </Typography>
      </Box>
      <Box>
         <Typography
            variant="subtitle"
            sx={{
               color: "#16191e",
               fontSize: 12,
               paddingRight: {xs: 0, md:5},
            }} 
         >
            {`Site réalisé par Noé Caringi`}
         </Typography>
      </Box>
   </Box>
   </Box>
  );
};

export default Footer;